import { NotificationOutlined } from '@ant-design/icons';

import NotificationPage from '../pages/NotificationPage';

import { SiteMap } from './index';

export const notificationRoutes: SiteMap = {
  notification: {
    title: '알림',
    page: NotificationPage,
    icon: <NotificationOutlined />,
    key: '/notification',
    role: ['admin'],
    children: [
      {
        label: '알림 발송',
        icon: null,
        key: '/notification/dashboard',
      },
      // {
      //   label: '카톡 브랜드 메시지',
      //   icon: null,
      //   key: '/notification/brand-message',
      // },
      {
        label: '브랜드 메시지 결과',
        icon: null,
        key: '/notification/brand-message-result',
      },
      {
        label: '카카오 알림톡 발송',
        icon: null,
        key: '/notification/kakao-alimtalk',
      },
      {
        label: '전송 결과(카톡제외)',
        icon: null,
        key: '/notification/list',
      },
    ],
  },
};
